import { AnalyticsBrowser } from "@segment/analytics-next"
import * as env from "lib/env"

export const trackAnalytics = AnalyticsBrowser.load({
    writeKey: env.SEGMENT_WRITE_KEY,
})
